import React, { useEffect, useState } from 'react';
import FirstAccess from './FirstAccess'
import SignIn from './SignIn'

export default function Login() {
	const [challenge, setChallenge] = useState({})
	const [form, setForm] = useState('SignIn')

	const forms = {
		SignIn: <SignIn setChallenge={setChallenge} setForm={setForm} />,
		FirstAccess: <FirstAccess challenge={challenge} setForm={setForm} />,
	}

	useEffect(() => {
		document.title = 'HarpiAI APP | Login'
	}, [])

	return forms[form]
}
